var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 16,
    viewBox: "0 0 130 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4783 11.5134L12.8446 14L11.6859 9.31337L15.5435 6.16004L10.4636 5.75337L8.4783 1.33337L6.49298 5.75337L1.41309 6.16004L5.27069 9.31337L4.112 14L8.4783 11.5134Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7393 11.5134L41.1056 14L39.9469 9.31337L43.8045 6.16004L38.7246 5.75337L36.7393 1.33337L34.754 5.75337L29.6741 6.16004L33.5317 9.31337L32.373 14L36.7393 11.5134Z",
    fill: "#FFA800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 11.5134L69.3663 14L68.2076 9.31337L72.0652 6.16004L66.9854 5.75337L65 1.33337L63.0147 5.75337L57.9348 6.16004L61.7924 9.31337L60.6337 14L65 11.5134Z",
    fill: "#FFA800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.261 11.5134L97.6273 14L96.4686 9.31337L100.326 6.16004L95.2463 5.75337L93.261 1.33337L91.2757 5.75337L86.1958 6.16004L90.0534 9.31337L88.8947 14L93.261 11.5134Z",
    fill: "#FFA800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.522 4.75337L122.207 6.28004L122.539 7.02004L123.387 7.08671L125.132 7.22671L123.804 8.31337L123.161 8.84004L123.352 9.62671L123.747 11.2334L122.249 10.38L121.522 9.95337L120.794 10.3667L119.296 11.22L119.692 9.61337L119.883 8.82671L119.24 8.30004L117.911 7.21337L119.657 7.07337L120.504 7.00671L120.836 6.26671L121.522 4.75337ZM121.522 1.33337L119.536 5.75337L114.457 6.16004L118.314 9.31337L117.155 14L121.522 11.5134L125.888 14L124.729 9.31337L128.587 6.16004L123.507 5.75337L121.522 1.33337Z",
    fill: "#FFA800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.2db41a2985332d2ee2ae7b2202412439.svg";
export { ForwardRef as ReactComponent };